import React from "react";
import { CustomData } from "types/Models/reviewDocumentAndBalancingPayment";
import { Button } from "components/DesignSystem/Button/Button";
import { DownloadIcon } from "components/icons/Download";
import { SmallMultipleFiles } from "components/icons/SmallMultipleFiles";
import TinySuccess from "static/images/TinySuccess.svg";
import { pluralize } from "utils/pluralize";
import { ClampedTextWithTooltip } from "utils/ClampedTextWithTooltip";

export const PricingAndDescription = ({
  price,
  description,
}: {
  price: string;
  description?: string | null;
}) => {
  return (
    <div className="t-space-y-1.5">
      <div className="t-text-subtext t-text-text-60">${price}</div>
      {description && (
        <ClampedTextWithTooltip
          text={description}
          lineClampElementClass="t-line-clamp-2 t-text-body-sm t-text-text-30"
          toolTipClass="t-w-64 t-word-break"
        />
      )}
    </div>
  );
};

export const ReviewChatCardBody = ({
  customData,
  downloadFiles,
  isPaymentRequired,
}: {
  customData: CustomData;
  downloadFiles: () => void;
  isPaymentRequired?: boolean;
}) => {
  const reviewedFilesCount =
    customData?.ctas?.[0]?.metadata?.file_data?.filter(
      (file) => file.is_reviewed
    ).length ?? 0;

  const totalFilesCount =
    customData?.ctas?.[0]?.metadata?.file_data?.length || 0;

  const links =
    customData?.ctas?.[0]?.metadata?.links || customData?.metadata?.links || [];

  const reviewedLinksCount = links.filter((link) => link.is_reviewed).length;

  const totalCount = totalFilesCount + links.length;
  const totalReviewedCount = reviewedFilesCount + reviewedLinksCount;

  return (
    <div>
      {customData.price && (
        <>
          <PricingAndDescription
            price={customData.price}
            description={customData.description}
          />
          <div className="t-border t-border-dashed t-border-neutral-10 t-border-t-0 t-border-l-0 t-border-r-0 t-mt-3 t-mb-2"></div>
        </>
      )}

      {totalCount > 0 && (
        <div className="t-flex t-justify-between t-items-center">
          <div className="t-flex t-gap-3 t-items-center">
            <div className="t-h-6 t-w-6 t-rounded-full t-border t-border-solid t-border-neutral-0 t-flex t-items-center t-justify-center t-relative">
              <SmallMultipleFiles />
              {totalReviewedCount === totalCount && totalCount > 0 ? (
                <img
                  src={TinySuccess}
                  alt="TinySuccess"
                  className="t-bottom-0 t-right-0 t-absolute"
                />
              ) : (
                <div className="t-min-w-1.5 t-min-h-1.5 t-max-h-1.5 t-max-w-1.5 t-rounded-full t-bottom-0 t-right-0 t-absolute t-bg-orange" />
              )}
            </div>

            <div>
              <div className="t-text-subtext t-text-text-60">
                {pluralize(totalCount, "Attachment", "Attachments")}
              </div>
              <div className="t-text-text-30 t-text-subtext-sm">
                {totalReviewedCount}/{totalCount} Reviewed
              </div>
            </div>
          </div>
          <Button customType="ghost_icon" size="xsmall" onClick={downloadFiles}>
            <span className="t-text-text-60">
              <DownloadIcon color="currentColor" strokeWidth="1" size={24} />
            </span>
          </Button>
        </div>
      )}
    </div>
  );
};
